import React from "react"
import { makeStyles } from "@material-ui/styles"
import Typography from "@material-ui/core/Typography"
import { Grid, RichDescription, RichTitle } from ".."
import Img from "gatsby-image"

const useStyles = makeStyles(theme => {
  return {
    root: {
      background: props =>
        props.color
          ? theme.palette[props.color]
            ? theme.palette[props.color].supportLightBackground ||
              theme.palette[props.color].support
            : props.color
          : null,
      flexDirection: "column",
      position: "relative",
      zIndex: 0,
      margin: theme.spacing(5, 0),
      padding: theme.spacing(4),
    },
    noTopPaddingRoot: {
      background: props =>
        props.color
          ? theme.palette[props.color]
            ? theme.palette[props.color].supportLightBackground ||
              theme.palette[props.color].support
            : props.color
          : null,
      flexDirection: "column",
      position: "relative",
      zIndex: 0,
      [theme.breakpoints.up("lg")]: {
        padding: theme.spacing(0, 0, 10, 0),
      },
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(0, 0, 7, 0),
      },
    },

    grid: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap-reverse",
      },
    },
    gridItem: {
      alignSelf: "center",
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.between("md", "lg")]: {
        margin: 0,
      },
      [theme.breakpoints.up("lg")]: {
        margin: 0,
      },
      [theme.breakpoints.down("md")]: {
        margin: "auto",
      },
    },
    copy: {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        alignItems: "center",
        marginLeft: 0,
        marginRight: 0,
        width: "100%",
        textAlign: "center",
      },
    },
    copyText: {
      // marginBottom: theme.spacing(6),
      display: "block",
      textAlign: "justify",
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        // marginBottom: theme.spacing(2),
        marginTop: theme.spacing(4),
      },
    },
    titleText: {
      color: theme.palette.black.main,
      marginBottom: theme.spacing(4),
      textAlign: "left",
      [theme.breakpoints.between("md", "lg")]: {
        marginTop: theme.spacing(1),
      },
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
        marginTop: theme.spacing(4),
      },
    },
    leafLeft: {
      position: "absolute",
      left: "6%",
      bottom: "10px",
      width: 80,
      height: 77,
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    leafRight: {
      position: "absolute",
      right: 0,
      bottom: "10%",

      width: 80,
      height: 77,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    image: {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
    imageWrapper: {
      height: theme.spacing(45),
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        height: theme.spacing(40),
      },
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(1.25),
    },
    backdrop: {
      alignItems: "flex-end",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      position: "absolute",
      left: 0,
      top: 0,
      width: "50%",
      zIndex: -1,
      "& img": {
        height: "95%",
        opacity: 0.4,
      },
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    textCenter: {
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  }
})

export default props => {
  const classes = useStyles(props)

  return (
    <div
      className={props.noTopPadding ? classes.noTopPaddingRoot : classes.root}
    >
      <Grid
        xs={8}
        container
        centered="true"
        className={classes.grid}
        spacing={0}
      >
        <Grid item xs={8} lg={6} centered="true" className={classes.gridItem}>
          <div className={classes.copy}>
            {props.bgImgLeft && (
              <img
                src={props.bgImgLeft}
                className={classes.leafLeft}
                alt={""}
              />
            )}

            {props.titleText.content && (
              <div>
                <RichTitle titleText={props.titleText} />
              </div>
            )}

            {props.copyText.content && (
              <div className={classes.copyText}>
                <RichDescription copyText={props.copyText} />
              </div>
            )}
          </div>
        </Grid>
        {props.imageSrc && (
          <Grid item xs={8} lg={8} centered="true" className={classes.gridItem}>
            <div className={classes.imageWrapper}>
              {props.mediaType === "Video" && (
                <video
                  src={props.videoSrc}
                  width="100%"
                  height="100%"
                  preload="auto"
                  loop
                  autoPlay
                  muted
                />
              )}
              {props.mediaType === "Image" && (
                <Img
                  className={classes.image}
                  fluid={props.imageSrc}
                  alt={""}
                />
              )}
            </div>
          </Grid>
        )}
        {props.mediaCaption && (
          <Grid item xs={8} lg={8} centered="true" className={classes.gridItem}>
            <Typography variant={"body2"} className={classes.textCenter}>
              {props.mediaCaption}
            </Typography>
          </Grid>
        )}
      </Grid>
      {!props.hideBackground && (
        <div className={classes.backdrop}>
          <img src={props.backdropSrc} alt={""} />
        </div>
      )}
    </div>
  )
}
